import { render, staticRenderFns } from "./SidebarLateral.vue?vue&type=template&id=0f545d23&scoped=true"
import script from "./SidebarLateral.vue?vue&type=script&lang=js"
export * from "./SidebarLateral.vue?vue&type=script&lang=js"
import style0 from "./SidebarLateral.vue?vue&type=style&index=0&id=0f545d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f545d23",
  null
  
)

export default component.exports